var map = {
	"./01.png": 48244,
	"./02.png": 70703,
	"./03.png": 85606,
	"./04.png": 90585,
	"./05.png": 58480,
	"./06.png": 23883,
	"./banner.png": 48483,
	"./default.jpg": 11802,
	"./fengjing.png": 54181,
	"./jiaotong.png": 81668,
	"./map.png": 67391,
	"./tongzhi.png": 93636,
	"./xydt.png": 1940
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21881;